// This renders the content both for the privacy policy and the terms of conditions
import { HashLink as Link } from "react-router-hash-link";
import { useSelector } from "react-redux";
import Icon from "@identitybuilding/idb-react-iconlib";
import Meta from "../_general/Meta";
import Privacy_anonymous from "../../library/imgs/privacy_anonymous.png";
import Privacy_entrepreneur from "../../library/imgs/privacy_entrepreneur.png";
import Conditions from "../../library/ondernemersnetwerk-100procentlokaal-voorwaarden.pdf";
import Privacy_fully_anonymous from "../../library/imgs/privacy_fully_anonymous.png";
import Privacy_logged_in from "../../library/imgs/privacy_logged_in.png";
import React from "react";

const Policy = () => {
  const lang = useSelector((state) => state.general.lang);
  const translate = useSelector((state) => state.general.translate);

  return (
    <div id="privacy" className="pol">
      <Meta
        description={translate("privacy_description")}
        title={translate("privacy_title")}
      />
      <div className="homeBtn">
        <Link title="Home" to="/#top">
          <Icon name="Home" />
        </Link>
      </div>
      <div id="policy">
        {/* The privacy identity card of the user */}
        <div className="privacyHead">
          <div className="privacyHeadContent">
            <div className="privacyLogo">
              <Link to="/">
                <img
                  className="logo"
                  src={require(`../../library/imgs/logos/esn/logo_esn_invert_${lang}.svg`)}
                  alt={translate("policy_esn_logo_alt")}
                />
              </Link>
              <p>{translate("privacy_intro")}</p>
            </div>
            <div className="privacyID fade-in-bottom">
              <h2>{translate("policy_id_0")}</h2>
              <div className="idCardImage">
                <img src={Privacy_anonymous} alt={translate("anonymous")} />
              </div>
              <div className="idCardContent">
                <Link to="/privacy/policy/#standard_user">
                  {translate("policy_id_1")}
                </Link>
                <Link to="/privacy/policy/#standard_user">
                  {translate("policy_id_2")}
                </Link>
                <Link to="/privacy/policy/#standard_user">
                  {translate("policy_id_3")}
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* The start of the privacy policy */}
        <div className="privacyBody">
          <h1>{translate("policy_title")}</h1>
          {translate("policy_intro")}
          <ol>
            <li>
              <Link to="/privacy/policy#standard_user">
                {translate("standard_users")}
              </Link>
            </li>
            <li>
              <Link to="/privacy/policy#logged_user">
                {translate("logged_users")}{" "}
              </Link>
            </li>
            <li>
              <Link to="/privacy/policy#entrepreneurs_user">
                {translate("enterpreneur_users")}{" "}
              </Link>
            </li>
          </ol>
        </div>

        {/* Information for the anonymous users */}
        <div className="pUserBlock" id="standard_user">
          <div className="pUserBlockWrapper">
            <div className="pBlockImage">
              <img
                src={Privacy_fully_anonymous}
                alt={translate("regular_user")}
              />
            </div>
            <div className="pBlockContent">
              <div className="pTitleWrapper">
                <span>1</span>
                <div className="pTitle">
                  <h3>{translate("standard_users_title")}</h3>
                  <h4>{translate("standard_users_subtitle")}</h4>
                </div>
              </div>
              {translate("standard_users_content")}
            </div>
          </div>
        </div>

        {/* Information for the logged in users */}
        <div className="pUserBlock pBlockRight" id="logged_user">
          <div className="pUserBlockWrapper">
            <div className="pBlockImage">
              <img src={Privacy_logged_in} alt={translate("logged_user")} />
            </div>
            <div className="pBlockContent">
              <div className="pTitleWrapper">
                <span>2</span>
                <div className="pTitle">
                  <h3>{translate("logged_users_title")}</h3>
                  <h4>{translate("logged_users_subtitle")}</h4>
                </div>
              </div>
              {translate("logged_users_content")}
            </div>
          </div>
        </div>

        {/* Information for the entrepreneur users */}
        <div className="pUserBlock" id="entrepreneurs_user">
          <div className="pUserBlockWrapper">
            <div className="pBlockImage">
              <img
                src={Privacy_entrepreneur}
                alt={translate("entrepreneurs")}
              />
            </div>
            <div className="pBlockContent">
              <div className="pTitleWrapper">
                <span>3</span>
                <div className="pTitle">
                  <h3>{translate("enterpreneur_users_title")}</h3>
                  <h4>{translate("enterpreneur_users_subtitle")}</h4>
                </div>
              </div>
              {translate("enterpreneur_users_content_0")}
              {translate("enterpreneur_users_content_1")}
              {translate("enterpreneur_users_content_2")}
            </div>
          </div>
        </div>

        {/* A quote by identityBuilding */}
        <div className="privacyQuote">
          <div className="quoteWrapper">
            <Icon name="QuoteOpenFill" />
            <h2>{translate("privacy_quote")}</h2>-<h3>identityBuilding bv</h3>
            <Icon name="QuoteClosedFill" />
          </div>
        </div>

        {/* Information about the analytical data */}
        <div className="privacyBody">
          <h3>{translate("privacy_analytical_title_0")}</h3>
          <h5>{translate("privacy_analytical_title_1")}</h5>
          {translate("privacy_analytical_content")}
        </div>

        {/* The Terms and conditions part of the policy*/}
        <div className="privacyBody privacyTermsBody">
          <h2 id="terms">{translate("terms_title_special")}</h2>
          <a href={Conditions} target="_blank">
            Bekijk hier onze {translate("terms_title_special")}
          </a>

          <h2 id="terms">{translate("terms_title_0")}</h2>
          <p>{translate("terms_intro")}</p>
          <h5>{translate("terms_title_1")}</h5>
          <ol className="unordered">
            <li>{translate("terms_0")}</li>
            <li>{translate("terms_1")}</li>
            <li>{translate("terms_2")}</li>
          </ol>
          <h5>{translate("terms_title_2")}</h5>
          <ol className="unordered">
            <li>{translate("terms_consequence_0")}</li>
            <li>{translate("terms_consequence_1")}</li>
            <li>{translate("terms_consequence_2")}</li>
            <li>{translate("terms_consequence_3")}</li>
          </ol>

          <h5>{translate("terms_title_3")}</h5>
          <p>{translate("terms_excuse_content")}</p>

          {/* The enterprise contact information */}
          <h3>{translate("terms_contact_title")}</h3>
          <p>{translate("terms_contact_content")}</p>
          <a href="mailto:support@identityBuilding.be">
            support@identityBuilding.be
          </a>
          <ul>
            <li>identityBuilding bv</li>
            <li>
              <Icon name="Facebook" />
              <a href="https://www.facebook.com/identityBuildingBelgium">
                @identityBuildingBelgium
              </a>
            </li>
            <li>
              <Icon name="Website" />
              <a href="https://identityBuilding.be">
                https://identityBuilding.be
              </a>
            </li>
            <li>
              <Icon name="Mapmarker" />
              Kuilstraat 1, 9420 Erondegem (Erpe-Mere)
            </li>
            <li>
              <Icon name="Phone" />
              +32(0)4 97 579 777
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Policy;
